import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/AuthProvider";
import { Logout as LO } from "../../db_access/logout";
import { clearAllCache } from "../../utilities/queryClient";

const Logout = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const logOut = async () => {
    // Both backend and local cleanup are now unified in auth.logout()
    await auth.logout();
    navigate("/");
  };
  useEffect(() => logOut(), []);
  return <></>;
};
export default Logout;
